export default `
  subscription OnDeleteCurrentTeamMember($userId: String!)  {
    onDeleteCurrentTeamMember (userId: $userId) {
      id
      projectId
      userId
    }
  }
`
